import analytics from 'APP_ROOT/services/analytics';
import { strings } from 'APP_ROOT/localization';

export default class MapboxToggleTrafficControl {

    mapboxTrafficIdPrefix;
    mapboxIncidentsIdPrefix;
    mapboxControlShouldDisplayTraffic;
    mapboxControlCallback;

    
    constructor(displayTrafficByDefault, callbackForButtonEventListener) {
        this.mapboxControlShouldDisplayTraffic = displayTrafficByDefault;
        this.mapboxControlCallback = callbackForButtonEventListener;
        this.mapboxTrafficIdPrefix = 'traffic';
        this.mapboxIncidentsIdPrefix = 'incident';
    }

    setTrafficVisiblity () {
        var scopedThis = this;
        var visibilityMode = this.mapboxControlShouldDisplayTraffic ? 'visible' : 'none';
        var style = this.map.getStyle();

        // go in and hide the traffic
        style.layers.forEach((layer) => {
            if (layer['id'].startsWith(scopedThis.mapboxTrafficIdPrefix)) {
                layer['layout'] = layer['layout'] || {};
                layer['layout']['visibility'] = visibilityMode;
            } else if(layer['id'].startsWith(scopedThis.mapboxIncidentsIdPrefix)) {
                layer['layout'] = layer['layout'] || {};
                layer['layout']['visibility'] = visibilityMode;
            }
        });

        // Update the style
        this.map.setStyle(style);
    }

    toggleTrafficVisiblity () {
        this.mapboxControlShouldDisplayTraffic = !this.mapboxControlShouldDisplayTraffic; // toggle
        this.mapboxControlCallback(this.mapboxControlShouldDisplayTraffic);

        this.setTrafficVisiblity();
    }

    buttonEventListener = () => {
        analytics.event({
            category: analytics.EventCategory.DashboardMap,
            action: analytics.EventAction.ToggleLayerVisibility,
            label: 'Traffic',
            value: this.mapboxControlShouldDisplayTraffic ? 0 : 1,
        });
        this.toggleTrafficVisiblity();
    }

    onStyleChange() {

        if (!this.map) {
            console.error("onStyleChange triggered while map property is invalid (" + (this.map) + "). Doing nothing.");
            return;
        }

        this.setTrafficVisiblity();
    }

    onAdd(map) {

        this.map = map;
        this.container = this.container();

        this.setTrafficVisiblity();

        return this.container;
    }

    onRemove() {
        this.container.parentNode.removeChild(this.container);
        this.mapboxComponentClassCallback = undefined;
        this.map = undefined;
    }

    button() {

        var imageElement = document.createElement('img');
        imageElement.src = '/images/map-btn-traffic.png';
        imageElement.alt = 'traffic';
        imageElement.style = "width: 30px; padding: 3px;"; /* using padding to shrink the icon down while keeping overall width 30px */

        var buttonElement = document.createElement('button');
        buttonElement.id = 'toggleTraffic';
        buttonElement.title = strings.map_controls_label_toggle_traffic;
        buttonElement.appendChild(imageElement);

        buttonElement.addEventListener('click', this.buttonEventListener);

        var buttonWrapper = document.createElement('div');
        buttonWrapper.appendChild(buttonElement);

        return buttonWrapper;
    }

    container() {
        var buttonWrapperContainer = document.createElement('div');
        buttonWrapperContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        buttonWrapperContainer.appendChild(this.button());
        return buttonWrapperContainer;
    }
}
